import classNames from 'classnames';
import MediaSave from '../../../block-ui/Media/media-save';
import { SliderItemPreview } from '../../../block-ui/Slider/slider-preview';

const PostSliderItem = ({
	className,
	post,
	mediaAspectRatio,
	isLinked,
	children,
}) => {
	const LinkTag = isLinked ? 'a' : 'span';
	const featuredMedia =
		post?.meta?.featured_media && JSON.parse(post.meta.featured_media);
	const featuredImage =
		post?._embedded?.['wp:featuredmedia']?.[0]?.source_url;
	return (
		<SliderItemPreview key={post.id}>
			<div
				className={classNames(
					'post-slider__item',
					`post-slider__item--${post.type}`,
					className
				)}
			>
				<LinkTag className="post-slider__link" href={post.link}>
					<div className="media-box post-slider__media-box">
						{featuredMedia && (
							<MediaSave
								className="post-slider__media media-box__media"
								value={featuredMedia}
								aspectRatio={mediaAspectRatio}
							/>
						)}
						{!featuredMedia && featuredImage && (
							<img
								className="post-slider__media media-box__media"
								src={featuredImage}
								alt=""
								style={{ aspectRatio: mediaAspectRatio }}
							/>
						)}
					</div>
					{children ?? (
						<div className="post-slider__title wp-block-button is-style-cta">
							<span className="wp-block-button__link">
								{/* eslint-disable */}
								<span
									dangerouslySetInnerHTML={{
										__html: post.title.rendered,
									}}
								/>
								{/* eslint-enable */}
							</span>
						</div>
					)}
				</LinkTag>
			</div>
		</SliderItemPreview>
	);
};

export default PostSliderItem;
